import { toLocalISO } from 'routes/Pages/GenTask/components/SharedFormFields';

export const DEFAULT_STORE_DATA = {
  pO_ReqNumber: 0,
  stock: '',
  departmentOrMachine: '',
  quantity: 0,
  transactionType: '',
  transactionDate: toLocalISO(),
  recordEnteredBy: '',
};
